export default {"src":"https://s.sylndr.com/c-9cd064a/_next/static/media/getLocation.74370420.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};